// split.io split names
export const SPLITS = {
  FF_OVERRIDES: 'web_oa_ff_overrides',
  DOWNLOAD_CSV: 'web_oa_download_csv',
  SHOW_TRACKS: 'web_oa_show_tracks',
  DWELL: 'web_oa_dwell',
  IMPORT_DXF: 'web_oa_import_dxf',
  EXPORT_DXF: 'web_oa_export_dxf',
  PLANNING_FLOORPLAN_COMPONENT: 'web_oa_planning_floorplan_component',
  OA_LIVE_CONNECTION: 'web_oa_live_connection',
  ELLIPTICAL_OA_COVERAGE: 'web_oa_elliptical_oa_coverage',
  HEIGHT_MAP: 'web_oa_height_maps',
  AUTOLAYOUT: 'web_oa_autolayout',
  SENSOR_COVERAGE: 'web_oa_sensor_coverage_simulation',
  OA_PLANNING_DISABLED: 'web_oa_planning_disabled',
  HIDE_STATUS_CHANGE_POPUP: 'web_oa_hide_status_change_popup',

  // incremental deprecation of OA app features
  RELEASE_1: 'web_oa_release_1',
  VIEW_PLANNING: 'web_oa_view_planning',
  VIEW_AVAILABILITY: 'web_oa_view_availability',
  VIEW_ANALYSIS: 'web_oa_view_analysis',

  // navbar and menu items shared with dashboard for deprecation
  VIEW_SPACES: 'web_dashboard_view_spaces',
  VIEW_ANALYTICS: 'web_dashboard_view_analytics',
  VIEW_DASHBOARDS: 'web_dashboard_view_dashboards',
  VIEW_LIVE: 'web_dashboard_view_live',
  VIEW_DISPLAYS: 'web_dashboard_view_displays',
  VIEW_OPEN_AREA: 'web_dashboard_view_open_area',
  MENU_LOCATIONS: 'web_dashboard_menu_locations',
  MENU_USER_MANAGEMENT: 'web_dashboard_menu_user_management',
  MENU_INTEGRATIONS: 'web_dashboard_menu_integrations',
  MENU_DEVELOPER: 'web_dashboard_menu_developer',
  MENU_ORGANIZATION_SETTINGS: 'web_dashboard_menu_organization_settings',
  MENU_SENSOR_STATUS: 'web_dashboard_menu_sensor_status',
  MENU_ACCOUNT: 'web_dashboard_menu_account',
  DEPRECATION_BANNER: 'web_dashboard_deprecation_banner',
} as const;

type Split = typeof SPLITS[keyof typeof SPLITS];

// features to override in split.io localhost mode
export const LOCAL_FEATURES: Record<Split, 'on' | 'off'> = {
  [SPLITS.FF_OVERRIDES]: 'on',
  [SPLITS.IMPORT_DXF]: 'on',
  [SPLITS.EXPORT_DXF]: 'on',
  [SPLITS.PLANNING_FLOORPLAN_COMPONENT]: 'on',
  [SPLITS.ELLIPTICAL_OA_COVERAGE]: 'on',
  [SPLITS.HEIGHT_MAP]: 'on',
  [SPLITS.AUTOLAYOUT]: 'on',
  [SPLITS.SENSOR_COVERAGE]: 'on',
  [SPLITS.OA_PLANNING_DISABLED]: 'off',
  [SPLITS.HIDE_STATUS_CHANGE_POPUP]: 'on',
  [SPLITS.DOWNLOAD_CSV]: 'on',
  [SPLITS.SHOW_TRACKS]: 'on',
  [SPLITS.DWELL]: 'on',
  [SPLITS.OA_LIVE_CONNECTION]: 'on',

  // incremental deprecation of OA app features
  [SPLITS.RELEASE_1]: 'on',
  [SPLITS.VIEW_PLANNING]: 'on',
  [SPLITS.VIEW_AVAILABILITY]: 'on',
  [SPLITS.VIEW_ANALYSIS]: 'on',

  // navbar and menu items shared with dashboard
  [SPLITS.VIEW_SPACES]: 'on',
  [SPLITS.VIEW_ANALYTICS]: 'on',
  [SPLITS.VIEW_DASHBOARDS]: 'on',
  [SPLITS.VIEW_LIVE]: 'on',
  [SPLITS.VIEW_DISPLAYS]: 'on',
  [SPLITS.VIEW_OPEN_AREA]: 'on',
  [SPLITS.MENU_LOCATIONS]: 'on',
  [SPLITS.MENU_USER_MANAGEMENT]: 'on',
  [SPLITS.MENU_INTEGRATIONS]: 'on',
  [SPLITS.MENU_DEVELOPER]: 'on',
  [SPLITS.MENU_ORGANIZATION_SETTINGS]: 'on',
  [SPLITS.MENU_SENSOR_STATUS]: 'on',
  [SPLITS.MENU_ACCOUNT]: 'on',
  [SPLITS.DEPRECATION_BANNER]: 'on',
};
